import * as React from "react";
var Option = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, value = _a.value;
    return (React.createElement("option", { disabled: disabled, value: value }, children));
};
export default Option;
//# sourceMappingURL=Option.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Select/Option.js
// module id = 1807
// module chunks = 17